import React from 'react'

const ConversionRateIcon: React.FC = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
   >
      <g opacity="0.7" clipPath="url(#clip0_66_125)">
         <path
            d="M31.0583 20.5H30.1689C29.8356 20.5 29.5049 20.5253 29.1756 20.576L19.7809 13.5307L22.0316 11.376C22.5636 10.8667 22.5823 10.0213 22.0729 9.49068C21.5623 8.95868 20.7169 8.94134 20.1876 9.44934L14.6236 14.776C14.3463 15.0533 13.9689 15.196 13.5729 15.1627C13.1756 15.1307 12.8263 14.9293 12.5876 14.596C12.2223 14.0893 12.3343 13.296 12.8116 12.8173L19.0823 6.91201C20.2703 5.79601 22.1276 5.52268 23.5809 6.25201L26.6689 7.79601C27.5889 8.25601 28.6209 8.49868 29.6489 8.49868H31.0569C31.7943 8.49868 32.3903 7.90268 32.3903 7.16534C32.3903 6.42801 31.7943 5.83201 31.0569 5.83201H29.6489C29.0316 5.83201 28.4116 5.68668 27.8596 5.41068L24.7743 3.86668C22.3423 2.64934 19.2369 3.10134 17.2529 4.97068L16.4289 5.74668L15.4956 4.89601C14.2703 3.78001 12.6836 3.16534 10.9756 3.16534C9.94761 3.16534 8.92227 3.40801 8.00627 3.86534L4.92094 5.40934C4.36761 5.68534 3.74761 5.83068 3.13027 5.83068H1.72494C0.987608 5.83068 0.391607 6.42668 0.391607 7.16401C0.391607 7.90134 0.987608 8.49734 1.72494 8.49734H3.13294C4.16094 8.49734 5.19294 8.25334 6.11427 7.79468L9.20227 6.25068C10.5649 5.56534 12.4796 5.75068 13.7009 6.86668L14.4836 7.58001L10.9556 10.9027C9.52494 12.332 9.29694 14.592 10.4249 16.1533C11.1183 17.1173 12.4956 17.832 13.6836 17.832C14.7409 17.832 15.7556 17.416 16.4889 16.6813L17.8303 15.3973L26.2916 21.7427C26.2503 21.772 18.0276 27.9373 18.0276 27.9373C17.0636 28.6867 15.7183 28.6867 14.7343 27.9227L6.61294 21.832C5.46761 20.972 4.04627 20.4987 2.61294 20.4987H1.72361C0.986274 20.4987 0.390274 21.0947 0.390274 21.832C0.390274 22.5693 0.986274 23.1653 1.72361 23.1653H2.61294C3.47294 23.1653 4.32494 23.4493 5.01294 23.9653L13.1156 30.0427C14.0823 30.7947 15.2409 31.1707 16.3969 31.1707C17.5463 31.1707 18.6943 30.7987 19.6463 30.0573L27.7703 23.9667C28.4569 23.4507 29.3089 23.1667 30.1689 23.1667H31.0583C31.7956 23.1667 32.3916 22.5707 32.3916 21.8333C32.3916 21.096 31.7956 20.5 31.0583 20.5Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_66_125">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0.391602 0.5)"
            />
         </clipPath>
      </defs>
   </svg>
)

export default ConversionRateIcon
